import {
    WITHDRAWAPPROVEREJECT_SUCCESS,
    WITHDRAWAPPROVEREJECT_FAILED,
    RESET_WITHDRAWAPPROVEREJECT,
    LOADING_WITHDRAWAPPROVEREJECT,
    NETWORK_ERROR_WITHDRAWAPPROVEREJECT
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_WITHDRAWAPPROVEREJECT:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case WITHDRAWAPPROVEREJECT_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case WITHDRAWAPPROVEREJECT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_WITHDRAWAPPROVEREJECT:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_WITHDRAWAPPROVEREJECT:
            return (state = initialState);
        default:
            return state;
    }
};